import React from 'react';
import PropTypes from 'prop-types';

export const HideSidebar = ({ width, height, ...props }) => (
  <svg
    data-icon='hide-sidebar'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M5 21c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 3 19V5c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 5 3h14c.55 0 1.02.196 1.413.587C20.803 3.98 21 4.45 21 5v14c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 19 21H5Zm4-2h10V5H9v14Z'
    />
  </svg>
);

HideSidebar.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

HideSidebar.defaultProps = {
  width: 24,
  height: 24,
};
